module.exports = __webpack_public_path__ + "img/zkhd-banner.b9f9b9b3.jpg";